var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "box" }, [_c("Listado")], 1),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "box" }, [
      _c("h1", { staticClass: "subtitle is-4" }, [
        _vm._v("Oficial de Registro"),
      ]),
      _vm._v(" "),
      _c("h1", { staticClass: "title is-3" }, [
        _vm._v("Oficiales de la organización"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("p", [
          _vm._v(
            'Usuarios de la organización con el rol "Oficial de registro".'
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }